import React from "react";

export const Title = ({ isEnabled, onToggle }) => {
  return (
    <div className="setting-setion m-b-10">
      <div className="membership-title">
        Sync Shopify
        <div className="memberRightActions">
          <span className="switch-text"></span>
          <label className="setting-switch pull-right">
            <input
              type="checkbox"
              name="is_enabled"
              id="is_enabled"
              checked={isEnabled}
              onChange={onToggle}
            />
            <span className="setting-slider"></span>
          </label>
        </div>
      </div>
    </div>
  );
};
